// extracted by mini-css-extract-plugin
export default {"valuesNote":"examples_valuesNote__Ui6Ig","examplesInfo":"examples_examplesInfo__tGN5a"};